/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { spendRulesRulesCreate } from "../funcs/spendRulesRulesCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { SpendRule } from "../models/components/spendrule.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateSpendRuleRequest,
  CreateSpendRuleSecurity,
} from "../models/operations/createspendrule.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type SpendRulesCreateRuleMutationVariables = {
  request: CreateSpendRuleRequest;
  security?: CreateSpendRuleSecurity | undefined;
  options?: RequestOptions;
};

export type SpendRulesCreateRuleMutationData = SpendRule;

export type SpendRulesCreateRuleMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createSpendRule spendRules
 *
 * @remarks
 * Create a new budget rule for the current organization.
 */
export function useSpendRulesCreateRuleMutation(
  options?: MutationHookOptions<
    SpendRulesCreateRuleMutationData,
    SpendRulesCreateRuleMutationError,
    SpendRulesCreateRuleMutationVariables
  >,
): UseMutationResult<
  SpendRulesCreateRuleMutationData,
  SpendRulesCreateRuleMutationError,
  SpendRulesCreateRuleMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildSpendRulesCreateRuleMutation(client, options),
    ...options,
  });
}

export function mutationKeySpendRulesCreateRule(): MutationKey {
  return ["@gram/client", "rules", "create"];
}

export function buildSpendRulesCreateRuleMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: SpendRulesCreateRuleMutationVariables,
  ) => Promise<SpendRulesCreateRuleMutationData>;
} {
  return {
    mutationKey: mutationKeySpendRulesCreateRule(),
    mutationFn: function spendRulesCreateRuleMutationFn({
      request,
      security,
      options,
    }): Promise<SpendRulesCreateRuleMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(spendRulesRulesCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
